import type { RatingCategory } from "../../../types";
import RatingPageCategoryCard from "./RatingPageCategoryCard/RatingPageCategoryCard";
import RatingPageNoResults from "./RatingPageNoResults";
import VolatileNotice from "./VolatileNotice";

interface RatingPageVpnsProps {
  ratingList: RatingCategory[];
  searchQuery: string;
}

function RatingPageVpns({ ratingList, searchQuery }: RatingPageVpnsProps) {
  const hasNoResults = ratingList.length === 0 && searchQuery.trim() !== "";

  return (
    <div className="hero-bg-image hero-bg-image-vpn-list bg-dark-blue flex flex-col flex-1 pb-5 md:pb-14 pt-3 md:pt-10">
      <VolatileNotice />

      {hasNoResults ? (
        <RatingPageNoResults searchQuery={searchQuery} />
      ) : (
        ratingList.map((rating, index) => (
          <RatingPageCategoryCard key={index} rating={rating} index={index} />
        ))
      )}
    </div>
  );
}

export default RatingPageVpns;
